import { Button } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { useMutation, useQuery } from "@tanstack/react-query";
import { Dayjs } from "dayjs";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast, ToastOptions } from "react-toastify";
import styled from "styled-components";
import { StyledButton } from "../../../../components/Button/button";
import { StyledDialog } from "../../../../components/dialog/dialog";
import { GoBackButton } from "../../../../components/GoBackButton";
import { LoadingBackDrop } from "../../../../components/loader";
import { StyledTable } from "../../../../components/table/styled-table";
import { theme } from "../../../../helpers/theme";
import { settings } from "../../../../helpers/toast.settings";
import { deleteAvailability } from "../../../../services/warehouses/availability-delete";
import { StorageAreaAvailabilityGetById } from "../../../../services/warehouses/storage-area-availability-get-by-id";
import { Availability, StorageArea } from "../../../../services/warehouses/storage-area-availability-get-by-id/types";


const SubcontractorsStorageAreaAvailability = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [openAvailabilityDialog, setOpenAvailabilityDialog] = useState(false);
  const [storageArea, setStorageArea] = useState<StorageArea[]>([]);
  const [magazineCode, setMagazineCode] = useState<string>("");
  const [deleteRowId, setDeleteRowId] = useState<string>("");
  // const [columns, setColumns] = useState<GridColDef[]>([
    // { 
    // field: "kod_magazynu", 
    // headerName: "Kod Magazynu", 
    // width: 250 
    // },
  //   {
  //     field: "kod",
  //     headerName: "Kod obszaru składowania",
  //     minWidth: 200,
  //     flex: 1
  //   },
  //   {
  //     field: "powierzchnia_dostepna",
  //     headerName: "Powierzchnia w m2",
  //     minWidth: 200,
  //     flex: 1
  //   },
  //   {
  //     field: "data_od",
  //     headerName: "Data od",
  //     minWidth: 150,
  //     flex: 1
  //   },
  //   {
  //     field: "data_do",
  //     headerName: "Data do",
  //     minWidth: 150,
  //     flex: 1
  //   },
  // ]);

  useEffect(() => {
  }, [openAvailabilityDialog])

  const settings: ToastOptions<{}> = {
    position: "top-center",
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: "light",
  };

  const DeleteAvailabilityMutation = useMutation(deleteAvailability, {
    onSuccess: () => {
      storageAreaAvailabilityGetById.refetch()
      toast.success("Usunięto pomyślnie!", { toastId: "DeletedSuccessfully", ...settings });
    },
  });


  // const handleEditModeOpen = () => {
  //   setEditMode(true);
  const columns: GridColDef[] = [
      { 
      field: "", 
      headerName: "Akcje", 
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      renderCell: (params) => (
        params.row.status_dostepnosci === 2 ? (
        <>
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
              marginRight: 10,
            }}
            onClick={() => {
              navigate(`/operator/subcontractors/storage-area-availability/edit/${params.row.id}`, { state: {id_magazyn: id, id_obszar: params.row.id_obszar_skladowania, status_dostepnosci: params.row.status_dostepnosci} });
            }}
          >
            Edytuj
          </Button>
          <Button
            variant="contained"
            style={{
              backgroundColor: "red",
            }}
            onClick={() => {
              setOpenAvailabilityDialog(true);
              setDeleteRowId(params.row.id);
            }}
          >
            Usuń
          </Button>
          
        </>
        ) : (
          <Button
            variant="contained"
            style={{
              backgroundColor: theme.colors.blue01_active,
              marginRight: 10,
            }}
            onClick={() => {
              navigate(`/operator/subcontractors/storage-area-availability/edit/${params.row.id}`, { state: {id_magazyn: id, id_obszar: params.row.id_obszar_skladowania, status_dostepnosci: params.row.status_dostepnosci} });
            }}
          >
            Edytuj
          </Button>
        )
      ), 
      },
      {
        field: "kod",
        headerName: "Kod obszaru składowania",
        minWidth: 200,
        flex: 1
      },
      {
        field: "powierzchnia_dostepna",
        headerName: "Powierzchnia w m2",
        minWidth: 200,
        flex: 1
      },
      {
        field: "data_od",
        headerName: "Data od",
        minWidth: 150,
        flex: 1
      },
      {
        field: "data_do",
        headerName: "Data do",
        minWidth: 150,
        flex: 1
      },
    ];
  

  // const handleEditModeClose = () => {
  //   setEditMode(false);
  //   setColumns([
  //     {
  //       field: "kod",
  //       headerName: "Kod obszaru składowania",
  //       minWidth: 200,
  //       flex: 1
  //     },
  //     {
  //       field: "powierzchnia_dostepna",
  //       headerName: "Powierzchnia w m2",
  //       minWidth: 200,
  //       flex: 1
  //     },
  //     {
  //       field: "data_od",
  //       headerName: "Data od",
  //       minWidth: 150,
  //       flex: 1
  //     },
  //     {
  //       field: "data_do",
  //       headerName: "Data do",
  //       minWidth: 150,
  //       flex: 1
  //     },
  //   ]);
  // }


  const body = {
    id_magazyn: String(id),
  };

  const storageAreaAvailabilityGetById = useQuery(["StorageAreaAvailability"], () => StorageAreaAvailabilityGetById(body), {
    refetchOnMount: true,
    refetchOnWindowFocus: false,

    onSuccess(data) {
      setMagazineCode(data.data.payload.kod_magazynu);
      setStorageArea(data.data.payload.obszar_skladowania);
    },
  });

  const dateFormating = (date: Date | Dayjs) => {
    const dateSeconds = Date.parse(date.toString());
    const dateObject = new Date(dateSeconds);
    return dateObject.toLocaleDateString("pl-PL");
  };

  const rows = storageArea.flatMap((r: StorageArea) => {
    return r.dostepnosc.map((d: Availability) => ({
      id: d.id_dostepnosc,
      id_obszar_skladowania: r.id_obszar_skladowania,
      kod: r.kod,
      powierzchnia_dostepna: d.powierzchnia_dostepna,
      data_od: dateFormating(d.data_od),
      data_do: dateFormating(d.data_do),
      status_dostepnosci: d.status_dostepnosci,
    }));
  });

  // console.log(rows);


  if (storageAreaAvailabilityGetById.isLoading || storageAreaAvailabilityGetById.isRefetching) {
    return <LoadingBackDrop loading={true} />;
  }

  return (
    <StorageAreaContainer>
      <StorageAreaHeader>Obszary składowania magazynu {magazineCode}</StorageAreaHeader>
      <ButtonsContainer>
        <GoBackButton description={"Powrót"} goToUrl={-1} />
        {/* <StyledButton style={{ marginLeft: "20px", display: editMode ? "none" : "block" }} onClick={handleEditModeOpen}>Zarządzaj dostępnością</StyledButton> */}
        <StyledButton style={{ marginLeft: "20px", backgroundColor:"green" }} onClick={()=>{navigate(`/operator/subcontractors/storage-area-availability/add/${id}`)}}>Dodaj przedział</StyledButton>
        {/* <StyledButton style={{ marginLeft: "20px", display: editMode ? "block" : "none" }} onClick={handleEditModeClose}>Zakończ</StyledButton> */}
      </ButtonsContainer>
      <TableContianer>
        <StyledTable
          disableExtendRowFullWidth={true}
          // getRowId={(row) => row?.id}
          rows={rows}
          columns={columns}
          // pageSize={5}
          disableSelectionOnClick={true}
          // autoPageSize
          autoHeight
        />
        <StyledDialog
            open={openAvailabilityDialog}
            setOpen={setOpenAvailabilityDialog}
            confirmFunction={() =>
              DeleteAvailabilityMutation.mutate({
                id_dostepnosc: deleteRowId
              })
            }
            dialogContent="Czy na pewno chcesz usunąć dostępność?"
          />
      </TableContianer>
    </StorageAreaContainer>
  );
}

export default SubcontractorsStorageAreaAvailability;

const StorageAreaContainer = styled.div`
  // width: 51%;
  // height: 800px;
  // padding: 100px;
  margin-left: 0;
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 20px;

  @media ${theme.device.laptop} {
    margin-left: 310px;
  }
`;

const StorageAreaHeader = styled.h2`
  font-family: ${theme.fonts.interRegular};
  text-align: center;

  @media ${theme.device.laptop} {
    text-align: left;
  }
`;

const ButtonsContainer = styled.div`
  display: flex;
  // justify-content: space-between;
`;

const TableContianer = styled.div`
  display: flex;
  justify-content: center;
  // height: 600px;
  margin-left: 10px;
  margin-right: 10px;

  @media ${theme.device.laptop} {
    margin-right: 40px;
  }
`;